import { useCallback } from "react";
import EmojiReactionsContainer from "modules/emoji/Reactions/EmojiReactionsContainer";
import { SurveyContainer } from "modules/guestExperienceSurvey";
import { useAppDispatch } from "store/hooks";
import { RightPanelContainer, TABS, setPanelState } from "modules/rightPanel";
import { DailyContainer } from "modules/audioVideo/components/DailyContainer";
import BroadcastStreamingContainer from "../../layout/BroadcastStreamingContainer";
import BroadcastTotalRequests from "../../BroadcastTotalRequests";
import AudienceView from "../../AudienceView/AudienceView";
import "./styles.scss";

const BroadcastDefaultView = (): JSX.Element | null => {
  const dispatch = useAppDispatch();
  const openParticipantsPanel = useCallback(() => {
    dispatch(setPanelState({ tabId: TABS.PARTICIPANTS, isOpen: true }));
  }, [dispatch]);

  return (
    <div className="panels-wrapper" data-testid="broadcast-default-view">
      <div className="main-panel-container">
        <div className="main-panel">
          <BroadcastTotalRequests onView={openParticipantsPanel} />
          <BroadcastStreamingContainer>
            <DailyContainer />
          </BroadcastStreamingContainer>
        </div>
        <AudienceView />
      </div>
      <RightPanelContainer />
      <EmojiReactionsContainer />
      <SurveyContainer />
    </div>
  );
};

export default BroadcastDefaultView;
